module.exports = __webpack_public_path__ + "media/images/sp/top/hairstyle_header_bg@2x-4d7e7aa7605ed2b09f3b785b36879b80.webp";